import {FunctionComponent, useEffect} from 'react';

interface TagManagerInitializationProps {
  id?: string | null;
  locale?: string | null;
}

const OneTrustInitializer: FunctionComponent<TagManagerInitializationProps> = ({id, locale}) => {
  useEffect(() => {
    if (!id || !locale) {
      return;
    }

    const script = document.createElement('script');
    script.src = `https://cdn.cookielaw.org/consent/${id}/otSDKStub.js`;
    script.setAttribute('data-language', locale);
    script.setAttribute('data-domain-script', id);

    const optanonScript = document.createElement('script');
    optanonScript.innerHTML = 'function OptanonWrapper() {}';

    const initScript = document.createElement('script');
    initScript.id = 'one-trust-init';
    initScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];

      function gtag(){dataLayer.push(arguments);}

      gtag("consent", "default", {
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        analytics_storage: "denied",
        functionality_storage: "denied",
        personalization_storage: "denied",
        security_storage: "granted",
        wait_for_update: 500,
      });
    `;

    document.head.appendChild(script);
    document.head.appendChild(initScript);
    document.head.appendChild(optanonScript);

    return () => {
      document.head.removeChild(script);
      document.head.removeChild(initScript);
      document.head.removeChild(optanonScript);
    };
  }, [id, locale]);

  return null;
};

export default OneTrustInitializer;
